<template>
  <div>
    <div class="modal" v-show="show">
      <div class="modal__logout">
        <div class="modal__logout__msg">
          <p>是否要注销帐号</p>
          <p class="modal__logout__urs">是否要退出客服系统</p>
        </div>
        <div class="modal__logout__btn" @click="cshow">取消</div>
        <div class="modal__logout__btn" @click="logout">确认</div>
      </div>
    </div>
    <div class="header">
      <div class="l-wrap">
        <a class="header__logo">塔人网络</a>
		<!-- <a class="news_nav" href="http://pay.tarenwang.com/" target="_blank">游戏充值</a> -->
		<a class="news_nav" href="/">客服首页</a>
		<a class="login__not" v-show="show1" @click='gologin()'>登录</a>
        <div class="login__already" v-show="show2">
          <div>
            <a><i msg-icon=""></i>&nbsp;&nbsp;{{name}}</a>
			<a @click='$router.push({path:"/tracklist"})'>服务记录追踪</a>
			<a @click='$router.push({path:"/"})'>切换账户</a>
            <a @click="ifshow" class="J-logout-btn"> 注销</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Top",
		data () {
		  return {
			show:false,
			show1:false,
			show2:false,
			name:''
		  }
		},
		methods:{
			ifshow(){
				this.show=true
			},
			cshow(){
				this.show=false
			},
			logout(){
				var self=this
				$.get('/index.php/user/User/loginout').then(function(){
					self.show=false
					//localStorage.clear();
					document.cookie=''
					window.location.href='https://oauth.tarenwang.net/api/logout?redirect_uri=https://rokf-wegame.zhaouc.com/'
				})
				//this.$router.push({path:"/rologin"})
			}
		},
		created() {
		  function getCookie(cname)
		  {
		    var name = cname + "=";
		    var ca = document.cookie.split(';');
		    for(var i=0; i<ca.length; i++)
		    {
		      var c = ca[i].trim();
		      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
		    }
		    return "";
		  }
		setInterval(() => {
		    let uid=getCookie('user_name')
		    if(!uid){
		      this.show1=true
		    this.gologin()
		      //this.$router.push({path:"/rologin"})
		    }else{
				var ph = localStorage.getItem('phone');
				if(ph){
					this.name=decodeURI(uid)
				}else{
					this.name=decodeURIComponent(uid)
				}
		      this.show2=true
		    }
		}, 500);

		}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/top.vue